import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignOutAlt,
  faBars,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import DoctorFooter from "./DoctorFooter";
import styles from "./DoctorPortal.module.css";
import logoBg from "../../static/logobgr.png";

const DoctorPortalLayout = ({
  children,
  activePage = "schedule",
  setActivePage,
  doctorName = "Doctor",
  handleLogout,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navItems = [
    { id: "schedule", label: "Schedule" },
    { id: "slots",    label: "Slots" },
    { id: "messages", label: "Messages" },
    { id: "blogs",    label: "Blogs" },
    { id: "shop",     label: "🛍 Shop" },
    { id: "profile",  label: "Profile" },
  ];

  const onNavClick = (id) => {
    if (setActivePage) setActivePage(id);
    setMenuOpen(false);
  };

  return (
    <div className={styles.portalWrapper}>
      {/* ─── FLOATING PERSISTENT ROUNDED NAVBAR ──────────────────────── */}
      <header className={styles.topNavbar} ref={navRef}>
        {/* Leftmost: Logo Image */}
        <div
          onClick={() => onNavClick("schedule")}
          className={styles.brandLink}
          role="button"
          tabIndex={0}
        >
          <img
            src={logoBg}
            alt="ReformMe Logo"
            style={{ height: "1.6rem", width: "auto", objectFit: "contain" }}
          />
        </div>

        {/* Middle: Doctor Name */}
        <div className={styles.middleDocName}>
          <span>
            {doctorName.startsWith("Dr.") ? doctorName : `Dr. ${doctorName}`}
          </span>
        </div>

        {/* Rightmost: Hamburger Sign */}
        <div className={styles.hamburgerWrap}>
          <button
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
            className={styles.hamburgerBtn}
            aria-label="Open Navigation Menu"
          >
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
          </button>

          {menuOpen && (
            <div className={styles.hamburgerMenu}>
              {navItems.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => onNavClick(item.id)}
                  className={`${styles.menuItem} ${
                    activePage === item.id ? styles.menuItemActive : ""
                  }`}
                >
                  <span>{item.label}</span>
                </button>
              ))}
              <div style={{ height: "1px", background: "#e2e8f0", margin: "4px 0" }} />
              <button
                type="button"
                onClick={() => {
                  setMenuOpen(false);
                  handleLogout();
                }}
                className={styles.menuItem}
                style={{ color: "#ef4444" }}
              >
                <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: "8px" }} />
                <span>Sign Out</span>
              </button>
            </div>
          )}
        </div>
      </header>

      {/* ─── MAIN PORTAL CONTENT AREA ────────────────────────────────── */}
      <main className={styles.mainContainer}>
        {children}
      </main>

      <DoctorFooter handleLogout={handleLogout} />
    </div>
  );
};

export default DoctorPortalLayout;
